import React from 'react';

import { GoogleIcon } from 'components/icons/GoogleIcon';
import { useTranslation } from 'contexts/translation-context';

export interface IGoogleAuthButtonProps {
  redirectUri: string;
}

export const GoogleAuthButton: React.FC<IGoogleAuthButtonProps> = (props) => {
  const { redirectUri } = props;
  const { i18n } = useTranslation();

  return (
    <button
      className="h-11 w-full rounded-md border border-border bg-surface text-sm font-medium text-fg-secondary hover:border-border-strong hover:bg-surface-hover hover:text-fg transition-colors cursor-pointer"
      onClick={() => {
        // eslint-disable-next-line no-restricted-globals
        window.location.href = `/api/auth/google/redirect?redirectUri=${encodeURI(redirectUri)}`;
      }}
    >
      <div className="flex h-full gap-2 items-center justify-center">
        <GoogleIcon className="w-4 h-4" />
        {i18n('auth.login.loginWithGoogle')}
      </div>
    </button>
  );
};
